<div class="content-dialog">

  <div class="hero">
    <span class="hero__icon"><mat-icon>smart_toy</mat-icon></span>
  </div>

  <div class="dialog-header">
    <h2 class="dialog-title">Persona no encontrada</h2>
    <p class="dialog-subtitle">
      No hay una persona registrada con este número{{ data?.documentNumber ? (' (' + (data.documentNumber | thousandsPipe) + ')') : '' }}.
      Elige cómo quieres registrarla.
    </p>
  </div>

  <ng-container [ngSwitch]="step">

    <div *ngSwitchCase="'choice'" class="options-stack">
      <div class="option-card option-card--recommended" *ngIf="canUploadDocument">
        <span class="option-badge"><mat-icon>auto_awesome</mat-icon> RECOMENDADO</span>

        <div class="option-card__top">
          <span class="option-card__icon">
            <mat-icon>description</mat-icon>
            <span class="option-card__icon-badge">IA</span>
          </span>
          <div class="option-card__text">
            <h3 class="option-title">Cargar Documento (IA) <mat-icon class="option-title__sparkle">auto_awesome</mat-icon></h3>
            <p class="option-description">Nuestra <strong>inteligencia artificial</strong> extraerá automáticamente los datos de tu {{ (data?.documentTypeLabel || 'documento') | lowercase }}.</p>
          </div>
        </div>

        <ngx-dropzone class="option-dropzone" [multiple]="false" (change)="onSelect($event)">
          <ngx-dropzone-label class="option-dropzone__label">
            <mat-icon class="option-dropzone__icon">cloud_upload</mat-icon>
            <span class="option-dropzone__text">Haz clic o arrastra tu documento aquí</span>
            <span class="option-dropzone__hint">PNG, JPG o PDF</span>
          </ngx-dropzone-label>
        </ngx-dropzone>
      </div>

      <button type="button" class="option-row" *ngIf="canManualRegistration" (click)="chooseManual()">
        <span class="option-row__icon"><mat-icon>assignment</mat-icon></span>
        <div class="option-row__text">
          <h3 class="option-title">Registro Manual</h3>
          <p class="option-description">Diligencia el formulario paso a paso.</p>
        </div>
        <mat-icon class="option-row__chevron">chevron_right</mat-icon>
      </button>
    </div>

    <div *ngSwitchCase="'uploading'" class="status-block">
      <mat-spinner diameter="48"></mat-spinner>
      <p class="status-text">Leyendo documento…</p>
    </div>

    <div *ngSwitchCase="'notice'" class="status-block notice-block">
      <mat-icon class="notice-icon">error_outline</mat-icon>
      <p class="status-text">{{ noticeMessage }}</p>

      <ngx-dropzone class="option-dropzone" *ngIf="canUploadDocument" [multiple]="false" (change)="onSelect($event)">
        <ngx-dropzone-label class="option-dropzone__label">
          <mat-icon class="option-dropzone__icon">cloud_upload</mat-icon>
          <span class="option-dropzone__text">Intentar con otro archivo</span>
          <span class="option-dropzone__hint">PNG, JPG o PDF</span>
        </ngx-dropzone-label>
      </ngx-dropzone>

      <button mat-button class="link-manual" *ngIf="canManualRegistration" (click)="chooseManual()">Continuar con registro manual</button>
    </div>

  </ng-container>

  <div class="actions-dialog" *ngIf="step !== 'uploading'">
    <button mat-stroked-button class="btn-cancelar" (click)="cancel()">CANCELAR</button>
  </div>
</div>
